var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    _vm.paddingClass,
    _vm.fontSizeClass,
    _vm.leadingClass,
    _vm.colorClass,
    _vm.shadowClass,
    _vm.radiusClass,
    'tw-font-sans tw-inline-flex tw-items-center tw-justify-center tw-border tw-border-transparent tw-rounded-md tw-transition tw-ease-in-out tw-duration-100 tw-relative',
  ],style:(_vm.customCircleSize),attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"tw-absolute tw-flex tw-items-center"},[_c('base-spinner',{attrs:{"size":_vm.spinnerSize,"current":""}})],1),_c('div',{class:[{ 'tw-invisible': _vm.loading }, 'tw-inline-flex tw-items-center']},[(_vm.$slots.icon)?_c('div',{class:['tw-h-3.5 tw-w-3.5', _vm.iconClass, _vm.iconColorClass, _vm.fontSizeClass]},[_vm._t("icon")],2):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }